import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { queryClient } from '@/lib/queryClient'
import {
  fetchSSOSettings,
  fetchSSOStatus,
  saveSSOSettings,
  type GoogleSSOWriteBody,
} from './api'

export const SSO_SETTINGS_KEY = ['auth', 'sso-settings'] as const
export const SSO_STATUS_KEY = ['auth', 'sso-status'] as const

// Outbox key (see apps/frontend/AGENTS.md "offline outbox").
export const SSO_SAVE_KEY = ['outbox', 'sso', 'save'] as const
queryClient.setMutationDefaults(SSO_SAVE_KEY, { mutationFn: saveSSOSettings })

export function useSSOSettings() {
  return useQuery({
    queryKey: SSO_SETTINGS_KEY,
    queryFn: fetchSSOSettings,
  })
}

export function useSaveSSOSettings() {
  const qc = useQueryClient()
  return useMutation({
    mutationKey: SSO_SAVE_KEY,
    mutationFn: (body: GoogleSSOWriteBody) => saveSSOSettings(body),
    onSuccess: (settings) => {
      qc.setQueryData(SSO_SETTINGS_KEY, settings)
      qc.invalidateQueries({ queryKey: SSO_STATUS_KEY })
    },
  })
}

// Public status probe — the login page shows the Google button when enabled.
// Never retried hard: an error simply means no button.
export function useSSOStatus() {
  return useQuery({
    queryKey: SSO_STATUS_KEY,
    queryFn: fetchSSOStatus,
    staleTime: 60_000,
    retry: false,
  })
}
